<template>
  <span>
    <AppValidationAlert
      v-if="isPony"
      :check-valid="ponyMeasurementIsValid"
      :valid="
        $t(
          'horses:appshow.PonyMeasurementStatus.valid.label',
          'Pony measurement valid',
          'Label for valid pony measurement status'
        )
      "
      :invalid="
        $t(
          'horses:appshow.PonyMeasurementStatus.expired.label',
          'Pony measurement expired',
          'Label for expired pony measurement status'
        )
      "
    />
  </span>
</template>
<script>
import gql from "fraql";
import AppValidationAlert from "@/components/elements/AppValidationAlert.vue";
import dayjs from "@/plugins/dayjs";

export default {
  name: "AppShowHorsePonyMeasurementStatus",
  components: { AppValidationAlert },
  props: {
    horse: {
      type: Object,
      default() {
        return {};
      }
    },
    checkDate: {
      type: String,
      default() {
        return dayjs().format("YYYY-MM-DD");
      }
    }
  },
  fragments: {
    horse: gql`
      fragment _ on Horse {
        id
        horseType
        ponyMeasurementEffectiveUntilDate
      }
    `
  },
  computed: {
    isPony() {
      return this.horse?.horseType == "pony";
    },
    ponyMeasurementIsValid() {
      return (
        this.isPony &&
        this.horse.ponyMeasurementEffectiveUntilDate &&
        this.ponyMeasurementIsValidOnDate
      );
    },
    ponyMeasurementIsValidOnDate() {
      return (
        this.$dayjs(this.horse.ponyMeasurementEffectiveUntilDate).unix() >
        this.$dayjs(this.checkDate).unix()
      );
    }
  }
};
</script>
